<template>
    <div class="carousel-item mt-offer-carousel-slide" v-bind:class="{'active' : index === 0}">
        <router-link :to="itemData.url">
            <img class="lazy" :data-src="itemData.image" :alt="itemData.imageAlt">
        </router-link>
        <div class="container">
            <div class="row">
                <div class="col my-auto">
                    <div class="mt-slide-info small mb-0 mt-c-grey" v-html="itemData.summary"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OfferCarouselItemTop",
        props: {
            itemData: {},
            index: Number
        },
        data() {
            return {}
        }
    }
</script>

<style scoped>
    .mt-offer-carousel-slide {
        text-align: center;
    }

    .mt-offer-carousel-slide img{
        max-width: 100%;
    }

    .mt-offer-carousel-slide .mt-slide-info {
        -webkit-transition: opacity 0.3s ease-in-out;
        -moz-transition: opacity 0.3s ease-in-out;
        -o-transition: opacity 0.3s ease-in-out;
        transition: opacity 0.3s ease-in-out;
    }

    .mt-offer-carousel-slide:not(.active) .mt-slide-info {
        opacity: 0;
    }

    .mt-offer-carousel-slide.carousel-item-left .mt-slide-info, .mt-offer-carousel-slide.carousel-item-right .mt-slide-info {
        opacity: 0;
    }

    .mt-offer-carousel-slide.carousel-item-next .mt-slide-info, .mt-offer-carousel-slide.carousel-item-prev .mt-slide-info {
        opacity: 1;
    }

    .mt-offer-carousel-slide.active:not(.carousel-item-next, .carousel-item-prev) .mt-slide-info {
        opacity: 1;
    }

    .mt-offer-carousel-slide {
        display: table-cell;
    }
</style>